module.exports = __webpack_public_path__ + "img/veza-2NP.61530530.png";